import XLSX from "xlsx";
function importToExcel(file, list, callback) {
  let arr = JSON.parse(JSON.stringify(list));
  // 读取本地excel文件
  if (!file) return;
  var rABS = false; //是否将文件读取为二进制字符串
  var f = file;
  var reader = new FileReader();
  var outdata;
  try {
    FileReader.prototype.readAsBinaryString = function (f) {
      var binary = "";
      var rABS = false; //是否将文件读取为二进制字符串
      var wb; //读取完成的数据
      var reader = new FileReader();
      reader.onload = function (e) {
        var bytes = new Uint8Array(reader.result);
        var length = bytes.byteLength;
        for (var i = 0; i < length; i++) {
          binary += String.fromCharCode(bytes[i]);
        }
        // var XLSX = require('xlsx');
        if (rABS) {
          wb = XLSX.read(btoa(fixdata(binary)), {
            //手动转化
            type: "base64"
          });
        } else {
          wb = XLSX.read(binary, {
            type: "binary"
          });
        }
        // outdata就是你想要的东西 excel导入的数据
        // 将返回的数据转换为json对象的数据
        outdata = sheetRowTwo(wb.Sheets[wb.SheetNames[0]]);
        // outdata = XLSX.utils.sheet_to_json(wb.Sheets[wb.SheetNames[0]], {
        //   header: 1
        // });
        //处理得到的结果
        callback(dealImportData(outdata, arr));
      };
      reader.readAsArrayBuffer(f);
    };
    if (rABS) {
      reader.readAsArrayBuffer(f);
    } else {
      reader.readAsBinaryString(f);
    }
  } catch (error) {
    alert("导入失败");
  }
  return outdata;
}
function sheetRowTwo(sheet, opts) {
  if (sheet == null || sheet["!ref"] == null) return [];
  var val = { t: 'n', v: 0 }, header = 0, offset = 1, hdr = [], v = 0, vv = "";
  var r = { s: { r: 0, c: 0 }, e: { r: 0, c: 0 } };
  var o = opts || {};
  var range = o.range != null ? o.range : sheet["!ref"];
  if (o.header === 1) header = 1;
  else if (o.header === "A") header = 2;
  else if (Array.isArray(o.header)) header = 3;
  else if (o.header == null) header = 0;
  switch (typeof range) {
    case 'string': r = safe_decode_range(range); break;
    case 'number': r = safe_decode_range(sheet["!ref"]); r.s.r = range; break;
    default: r = range;
  }
  if (header > 0) offset = 0;
  var rr = Number(XLSX.utils.encode_row(r.s.r)) + 1;
  var cols = [];
  var out = [];
  var outi = 0, counter = 0;
  var dense = Array.isArray(sheet);
  var R = 1, C = 0, CC = 0;
  if (dense && !sheet[R]) sheet[R] = [];
  for (C = r.s.c; C <= r.e.c; ++C) {
    cols[C] = XLSX.utils.encode_col(C);
    val = dense ? sheet[R][C] : sheet[cols[C] + rr];
    switch (header) {
      case 1: hdr[C] = C - r.s.c; break;
      case 2: hdr[C] = cols[C]; break;
      case 3: hdr[C] = o.header[C - r.s.c]; break;
      default:
        if (val == null) val = { w: "__EMPTY", t: "s" };
        vv = v = XLSX.utils.format_cell(val, null, o);
        counter = 0;
        for (CC = 0; CC < hdr.length; ++CC) if (hdr[CC] == vv) vv = v + "_" + (++counter);
        hdr[C] = vv;
    }
  }
  for (R = r.s.r + offset; R <= r.e.r; ++R) {
    var row = make_json_row(sheet, r, R, cols, header, hdr, dense, o);
    if ((row.isempty === false) || (header === 1 ? o.blankrows !== false : !!o.blankrows)) out[outi++] = row.row;
  }
  out.length = outi;
  return out;
}
function safe_decode_range(range) {
  var o = { s: { c: 0, r: 0 }, e: { c: 0, r: 0 } };
  var idx = 0, i = 0, cc = 0;
  var len = range.length;
  for (idx = 0; i < len; ++i) {
    if ((cc = range.charCodeAt(i) - 64) < 1 || cc > 26) break;
    idx = 26 * idx + cc;
  }
  o.s.c = --idx;

  for (idx = 0; i < len; ++i) {
    if ((cc = range.charCodeAt(i) - 48) < 0 || cc > 9) break;
    idx = 10 * idx + cc;
  }
  o.s.r = --idx;

  if (i === len || range.charCodeAt(++i) === 58) { o.e.c = o.s.c; o.e.r = o.s.r; return o; }

  for (idx = 0; i != len; ++i) {
    if ((cc = range.charCodeAt(i) - 64) < 1 || cc > 26) break;
    idx = 26 * idx + cc;
  }
  o.e.c = --idx;

  for (idx = 0; i != len; ++i) {
    if ((cc = range.charCodeAt(i) - 48) < 0 || cc > 9) break;
    idx = 10 * idx + cc;
  }
  o.e.r = --idx;
  return o;
}
function make_json_row(sheet, r, R, cols, header, hdr, dense, o) {
  var rr = XLSX.utils.encode_row(R);
  var defval = o.defval, raw = o.raw || !Object.prototype.hasOwnProperty.call(o, "raw");
  var isempty = true;
  var row = (header === 1) ? [] : {};
  if (header !== 1) {
    if (Object.defineProperty) try { Object.defineProperty(row, '__rowNum__', { value: R, enumerable: false }); } catch (e) { row.__rowNum__ = R; }
    else row.__rowNum__ = R;
  }
  if (!dense || sheet[R]) for (var C = r.s.c; C <= r.e.c; ++C) {
    var val = dense ? sheet[R][C] : sheet[cols[C] + rr];
    if (val === undefined || val.t === undefined) {
      if (defval === undefined) continue;
      if (hdr[C] != null) { row[hdr[C]] = defval; }
      continue;
    }
    var v = val.v;
    switch (val.t) {
      case 'z': if (v == null) break; continue;
      case 'e': v = void 0; break;
      case 's': case 'd': case 'b': case 'n': break;
      default: throw new Error('unrecognized type ' + val.t);
    }
    if (hdr[C] != null) {
      if (v == null) {
        if (defval !== undefined) row[hdr[C]] = defval;
        else if (raw && v === null) row[hdr[C]] = null;
        else continue;
      } else {
        row[hdr[C]] = raw ? v : XLSX.utils.format_cell(val, v, o);
      }
      if (v != null) isempty = false;
    }
  }
  return { row: row, isempty: isempty };
}

//处理得到的结果
function dealImportData(outdata, arr) {
  var columns = arr;
  var tHeader = {};
  columns.map(item => {
    if (item.key) {
      tHeader[item.key] = item.title;
    }
  });
  var dataList = [];
  outdata.map((item, index) => {
    var obj = {};
    for (var i in item) {
      for (var j in tHeader) {
        if (i == tHeader[j]) {
          obj[j] = item[i];
        }
      }
    }
    dataList.push(obj);
  });

  return dataList;
}
export default {
  importToExcel
};



// WEBPACK FOOTER //
// ./src/util/ExcelImportActive.js